import {useEffect, useRef, useState} from 'react';
import {Link} from "react-router-dom";
import {UseDelete, UsePost, UsePut} from "../../hooks/http";
import {UseLimit, UseOrder} from "../../hooks/settings";
import {UseMessage} from "../../hooks/UseMessage";

import ListingTable from "../../components/listing/listing";
import {UtcDateTimeToDateTime} from "../../hooks/dates";
import CardMenu from "../../components/card-menu";
import Menu from "./TopMenu";
import Button from "../../components/button";
import {Col, Modal, Row} from "react-bootstrap";
import Tabs from "rc-tabs";
import TabPane from "rc-tabs/lib/TabPanelList/TabPane";
import Text from "../../components/input/text";
import TabLabel from "../../components/tabLabel";
import {Plus} from "react-feather";
import UseGetFormData from "../../hooks/UseGetFormData";
import Textarea from "../../components/input/textarea";


const ConsentTypes = ({audience}) => {
    const [isLoading, setIsLoading] = useState(true)
    const [columns, setColumns] = useState([])
    const [entities, setEntities] = useState([])
    const [totalEntities, setTotalEntities] = useState(0)
    const [currentOffset, setCurrentOffset] = useState(0)
    const [currentLimit, setCurrentLimit] = useState(UseLimit)
    const [currentOrder, setCurrentOrder] = useState(UseOrder)
    const [searchValue, setSearchValue] = useState("")
    const [bulkAction, setBulkAction] = useState()
    const [lastChange, setLastChange] = useState(Date.now())
    const [showModal, setShowModal] = useState(false);

    const formRef = useRef()
    const [errors, setErrors] = useState()
    const [fields, setFields] = useState([])
    const AudienceMenu = Menu({audience: audience})


    const [searchColumn, setSearchColumn] = useState('mobile_phone')
    const [searchColumns, setSearchColumns] = useState([])


    const fetchData = async () => {
        let filters = {
            limit    : currentLimit,
            offset   : currentOffset,
            sortBy   : "created_at",
            sortOrder: currentOrder,
        };

        if (searchValue.trim() !== "") {
            filters["findBy"] = searchColumn;
            filters["findTerm"] = searchValue;
        }


        return await UsePut(`/audiences/${audience?._id?.$oid}/consents/types/get`,
            {data: filters}
        );

    };


    useEffect(() => {
        setIsLoading(true)
        fetchData().then((response) => {
            setEntities(response)
            setIsLoading(false)
        });
    }, [currentOffset, currentLimit, searchValue, currentOrder, lastChange]);


    const handleDelete = async (selected) => {
        if (selected.length === 0) {
            UseMessage("error", "Please choose some items")
        } else {

            await UseDelete(`/audiences/${audience?._id?.$oid}/consents/types/delete`,
                {
                    data: {idx: selected}, onSuccess: (response) => {
                        setLastChange(Date.now());
                    }
                }
            );
        }
    };


    const addNewEntity = () => {
        setShowModal(true)
    }


    const ListingOptions = {
        entities            : entities,
        isLoading           : isLoading,
        currentPage         : Math.ceil(currentOffset / currentLimit) + 1,
        totalEntities       : totalEntities,
        currentLimit        : currentLimit,
        currentOrder        : currentOrder,
        searchColumns       : searchColumns,
        template            : "table",
        searchColumn        : searchColumn,
        onSearch            : (value) => {
            setCurrentOffset(0);
            setSearchValue(value);
        },
        onChooseSearchColumn: (field) => {
            setSearchColumn(field.value)
        },
        onCleanSearch       : () => {
            setSearchValue("");
        },
        onChangePage        : (page) => {
            setCurrentOffset(currentLimit * (page - 1));
        },
        onChangeLimit       : (ev) => {
            UseLimit(setCurrentLimit, ev.target.text);
        },
        onChangeOrder       : (ev) => {
            UseOrder(setCurrentOrder, ev.target.text);
        },
        onChangeAction      : (action) => {
            setBulkAction(action);
        },
        onClickApply        : (selected) => {
            if (typeof bulkAction == "undefined") {
                UseMessage("error", "Please choose an action")
            } else {
                bulkAction["action"](selected);
            }
        },
        columns             : [
            {
                label: "Name", prop: "_id", size: 25, output: (entity) => {
                    return <Link to={`/audiences/${audience?._id?.$oid}/segments/${entity?._id?.$oid}`}>
                        <strong>{entity?.name}</strong>
                    </Link>;
                }
            },
            {label: "Slug", prop: "slug"},
            {label: "Description", prop: "description"},
            {
                label: "Created at", size: 15, prop: "created_at", output: (entity) => {
                    return UtcDateTimeToDateTime(entity?.created_at);
                }
            }
        ],
        filters             : [],
        actions             : [
            {value: "delete", label: "Delete", action: (selected) => handleDelete(selected)}
        ],
        rowActions          : [],
        addons              : {
            afterCard: <CardMenu {...AudienceMenu}/>,
            top      : {
                left:
                    <div className="d-flex">
                        <div className="me-2">
                            <Button
                                size="sm"
                                icon="plus"
                                color="primary"
                                isReady={!isLoading}
                                onClick={addNewEntity}
                                style={{height: '32px'}}
                            />
                        </div>
                    </div>
            }
        }
    };


    const handleSubmit = async (ev) => {
        ev.preventDefault()
        const FormData = UseGetFormData(formRef)


        const request = await UsePost(
            `/audiences/${audience?._id?.$oid}/consents/types/insert`,
            {data: [{name: FormData.get('name'), description: FormData.get('description')}]}
        )


        if (request?.code >= 200 && request?.code < 299) {
            setLastChange(Date.now())
            setShowModal(false)
        } else {
            setErrors(request?.errors)
        }

    }


    const handleModalClose = (ev) => {
        setShowModal(false);
    }


    const createTab = <TabLabel slug="preview" label="Create" icon={<Plus/>} errors={errors}/>

    return (
        <>
            <Modal size="md" className="add-sidebar-padding" centered show={showModal} onHide={handleModalClose}>
                <Modal.Header closeButton>
                    <Modal.Title as="h6">Create consent type</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Tabs defaultActiveKey="0">
                        <TabPane forceRender={true} key={'limits'} tabKey={'limits'} tab={createTab}>
                            <form ref={formRef} onSubmit={handleSubmit} autoComplete="off" style={{padding: '0px 15px 0px 15px'}}>
                                <Row>
                                    <Text
                                        name="name"
                                        label="Name"
                                        required={true}
                                        isReady={!isLoading}
                                        error={errors?.name}
                                        placeholder="Consent type name"
                                    />

                                    <Textarea
                                        required={true}
                                        name="description"
                                        label="Description"
                                        isReady={!isLoading}
                                        error={errors?.description}
                                        placeholder="A short description about this type"
                                    />

                                </Row>

                                <Button
                                    size="sm"
                                    icon="check"
                                    color="primary"
                                    label="Create"
                                    style={{marginTop: '20px'}}
                                    isReady={!isLoading}
                                />
                            </form>

                        </TabPane>
                    </Tabs>


                </Modal.Body>
            </Modal>
            <ListingTable {...ListingOptions} />
        </>
    )
}

export default ConsentTypes;